export const TAB_INFOS = {
  href: "/reconditionne/mon-compte",
  label: "Infos personnelles",
  labelMobile: "Infos",
};
export const TAB_REPARE = { href: "/reconditionne/mon-compte/reparation", label: "Réparation" };
export const TAB_ORDER = { href: "/reconditionne/mon-compte/commandes", label: "Commandes" };

export const TABS = [TAB_REPARE, TAB_INFOS, TAB_ORDER];
